import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { API_URL, setValToLS } from "../helpers";

import Alert from "../components/Alert";

const FriendsSigningin = () => {
  const [alert, setAlert] = useState({
    type: "working",
    text: "",
  });

  const history = useHistory();
  let { str } = useParams();

  useEffect(() => {
    const init = async () => {
      const url = new URL(`${API_URL}/auth/friendsDashSigninginInit`);
      const params = {
        token: str || "",
      };
      url.search = new URLSearchParams(params);

      try {
        const response = await fetch(url, {
          method: "GET",
          cache: "no-store",
        });
        const json = await response.json();
        if (json && json.resp === 1) {
          if (json.remember) {
            setValToLS("friendsDash", str);
          }
          setValToLS("friendsDash", str, true);
          history.push("/friends/dash");
        } else {
          setAlert({
            type: "error",
            text: json.text,
          });
        }
      } catch (error) {
        setAlert({
          type: "error",
          text: "An error has occurred.",
        });
      }
    };

    init();

    // eslint-disable-next-line
  }, []);

  return <Alert data={alert} />;
};

export default FriendsSigningin;
